import React from 'react';
import { Alert, Button, FormGroup, Table } from 'arag-ui-lib';
import { formatSolicitorTableLabel } from '../../helpers/functions';
import SolicitorFirmSearchSelect from '../solicitorFirmSearchSelect';
import CONTENT_STRINGS from '../../helpers/contentStrings';
const alertColumns = [
  { propertyName: 'id', header: 'Id', sortable: false, id: 'id' },
  {
    propertyName: 'solicitorFirmName',
    header: 'Solicitor Firm Name',
    formatter: (row) => formatSolicitorTableLabel({ label: row.solicitorFirmName, aragProvider: row.aragProvider }),
    sortable: false,
    id: 'solicitorGroupName',
  },
  { propertyName: 'caseType', header: 'Case type', sortable: false, id: 'caseType' },
  { propertyName: 'subCaseType', header: 'Sub case type', sortable: false, id: 'subCaseType' },
  { propertyName: 'validFrom', header: CONTENT_STRINGS.POLICY_LIVE_DATE_FROM, sortable: false, id: 'validFrom' },
  { propertyName: 'validTo', header: CONTENT_STRINGS.POLICY_LIVE_DATE_TO, sortable: false, id: 'validTo' },
]
const pageSizeOptions = [
  { key: 20, label: 20 },
  { key: 50, label: 50 },
  { key: 100, label: 100 },
  { key: 150, label: 150 },
  { key: 200, label: 200 },
];

const InternalAlerts = (props) => {
  const {user,
    internalAlerts,
    filterOptions,
    applyFilters,
    clearFilters,
    changeInternalAlertsSettings,
    push
  } = props;
  const page = internalAlerts.page;
 const isUserAllowed = user.loggedInUser.allowedToCreateInternalAlerts
  const caseTypesOptions = filterOptions.caseTypeOptions.map(c => { return { key: c.id, value: c.machineName, label: c.name, machineName: c.machineName } });
  const subCaseTypes = filterOptions.subCaseTypeOptions.map(c => { return { key: c.id, value: c.machineName, label: c.name, machineName: c.machineName } });

  const totalPages = Math.ceil(internalAlerts.alertsCount / props.internalAlerts.rowsPerPage);

  const internalAlertsData = internalAlerts.alerts.map(alert => {
    return {
      id: alert.id,
      solicitorFirmName: alert.solicitorFirmName,
      aragProvider: alert.aragProvider,
      caseType: alert.caseTypeName,
      subCaseType: alert.subCaseTypeName ?? "None",
      validFrom: new Date(alert.validFrom).toLocaleDateString("en-GB"),
      validTo: alert.validTo ? new Date(alert.validTo).toLocaleDateString("en-GB") : null,
    }
  })
  return (
    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
      <div >
        <h2 className="applicationsAndPolicies-h2">Internal Alerts</h2>
      </div>
      <div>
      {isUserAllowed &&
        <Button variant={'primary'} label={'Create new Internal Alert'} className='createNewBtn' arrowDirection={'right'} onClick={() => push("/new-internal-alert")} />
      }
        </div>

      <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', marginTop: '3%' }}>
        <SolicitorFirmSearchSelect
          labelSize={'col-sm-2'}
          inputSize={'col-sm-6'}
          label={'Solicitor firms'}
          instanceId={'solicitorFirms'}
          isMulti={true}
          onChange={(evt) => changeInternalAlertsSettings('filterFirms', evt)}
          value={internalAlerts.filterFirms}
        />
        <FormGroup
          labelSize={'col-sm-2'}
          inputSize={'col-sm-6'}
          label={'Case types'}
          variant={'multiSelect'}
          inputProps={{
            options: caseTypesOptions,
            onChange: (evt) => changeInternalAlertsSettings('filterCaseTypes', evt),
            value: internalAlerts.filterCaseTypes,
            isLoading: false,
            instanceId: 'caseTypes',
            isDisabled: false,
            required: false,
          }}
        />
        <FormGroup
          labelSize={'col-sm-2'}
          inputSize={'col-sm-6'}
          label={'Sub Case types'}
          variant={'multiSelect'}
          inputProps={{
            options: subCaseTypes,
            onChange: (evt) => changeInternalAlertsSettings('filterSubCaseTypes', evt),
            value: internalAlerts.filterSubCaseTypes,
            isLoading: false,
            instanceId: 'subCaseTypes',
            isDisabled: false,
            required: false,
          }}
        />
        <FormGroup
          labelSize={'col-sm-2'}
          inputSize={'col-sm-6'}
          label={CONTENT_STRINGS.POLICY_LIVE_DATE_FROM}
          variant={'date'}
          inputProps={{
            name: 'validFrom',
            dateInputProps: {
              onChange: ((evt) => { changeInternalAlertsSettings('filterValidFrom', evt) }),
              autoComplete: 'off',
              dateFormat: 'dd/MM/yyyy',
              selected: internalAlerts.filterValidFrom,
              placeholderText : 'DD/MM/YYYY'
            },
          }}
        />
        <FormGroup
          labelSize={'col-sm-2'}
          inputSize={'col-sm-6'}
          label={CONTENT_STRINGS.POLICY_LIVE_DATE_TO}
          variant={'date'}
          inputProps={{
            name: 'validTo',
            dateInputProps: {
              onChange: ((evt) => { changeInternalAlertsSettings('filterValidTo', evt) }),
              autoComplete: 'off',
              dateFormat: 'dd/MM/yyyy',
              selected: internalAlerts.filterValidTo,
              placeholderText : 'DD/MM/YYYY'
            },
          }}
        />
        <FormGroup
          labelSize={'col-sm-2'}
          inputSize={'col-sm-6'}
          label={'Search'}
          variant={'text'}
          inputProps={{
            onChange: (evt) => { props.changeInternalAlertsSettings('filterSearch', evt.target.value) },
            name: 'text',
            value: props.internalAlerts.filterSearch,
            required: false,
          }}
        />

        <div className='row'>
          <div className='col-xs-offset-2  col-sm-6'
            style={{ display: 'flex', gap: 10 }}
          >
            <Button variant={'primary'}
              label={'Filter'}
              arrowDirection={'right'}
              onClick={applyFilters}
            />

            <Button variant="tertiary"
              label={'Clear filters'}
              className='filterBtn'
              arrowDirection={'right'}
              onClick={clearFilters} />
          </div>
        </div>
      </div>

      <div>
      {internalAlerts.response !==''?
       
          <Alert variant="error" label={internalAlerts.response} /> :
          <Table
            loading={props.internalAlerts.fetching}
            orderAsc={false}
            striped
            columns={alertColumns}
            data={internalAlertsData}
            pageSize={internalAlerts.rowsPerPage}
            totalRecords={internalAlerts.alertsCount}
            totalPages={totalPages}
            page={page}
            goAtPrevious={() => page > 1 ? changeInternalAlertsSettings('page', page - 1) : null}
            goAtNext={() => page < totalPages
              ? changeInternalAlertsSettings('page', page + 1) : null}
            goAtStart={() => changeInternalAlertsSettings('page', 1)}
            goAtEnd={() => changeInternalAlertsSettings('page', totalPages)}
            goAtPage={(selectedPage) => changeInternalAlertsSettings('page', selectedPage)}
            hasActions
            actions={[
              { key: 'details', label: 'View/Edit', callback: (evt) => push("/internal-alerts/" + evt.id)},
            ]}
            pageSizeOptions={pageSizeOptions}
            onPageSizeChange={(evt) => changeInternalAlertsSettings('rowsPerPage', parseInt(evt.target.value))}

          />}
      </div>
    </div>

  )
}
export default InternalAlerts
